<template>
  <footer class="mobile_footer hidden-sm-and-up">
    <div class="footer_content">
      <div class="footer_links">
        <a href="http://www.gov.cn/">{{ $t('footer.government') }}</a>
        <a href="http://www.miit.gov.cn/">{{ $t('footer.ministryIndustry') }}</a>
        <a href="https://www.fmprc.gov.cn/chn/gxh/tyb/">{{ $t('footer.ministryForeign') }}</a>
      </div>
      <div class="footer_info">
        <p v-if="$t('footer.icp')">
          <span @click="handleAccountEntry" class="clickable-email">{{ $t('footer.email') }}</span>
        </p>
        <p>{{ $t('footer.copyright') }}</p>
        <p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('footer.icp') }}
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { isLoggedIn } from "@/utils/auth";

export default {
  methods: {
    handleAccountEntry() {
      const targetPath = isLoggedIn() ? "/controlCenter" : "/login";
      this.handleToRouter(targetPath);
    },
    handleToRouter(url) {
      this.$router.push(url).catch(() => {});
    },
    handleAccountClick() {
      this.handleToRouter(isLoggedIn() ? '/controlCenter' : '/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_footer {
  background: #1a1e22;
  padding: 1.25rem 0.9375rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.05);

  .footer_links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.9375rem;
    margin-bottom: 0.75rem;
    a {
      color: rgba(255, 255, 255, 0.4);
      font-size: 0.8125rem;
      text-decoration: none;
      transition: color 0.3s;
      &:hover {
        color: #03d2c5;
      }
    }
  }

  .footer_info {
    p {
      font-size: 0.8125rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.6;
      margin: 0;
      .clickable-email {
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          color: #03d2c5;
        }
      }
    }
    a {
      color: inherit;
      text-decoration: none;
      transition: color 0.3s;
      &:hover {
        color: #03d2c5;
      }
    }
  }
}
</style>
